import styles from "./StaticTable.module.css";

export default function TotalTable({ overAllTotal={} }) {
  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            <th className={styles.th}>OVERALL TOTAL</th>
            <th className={styles.th}>POSTED MANPOWER COUNT</th>
            <th className={styles.th}>TARGET</th>
            <th className={styles.th}>ACHIEVED</th>
            <th className={styles.th}>ACHIEVEMENT %</th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.dataRow}>
            <td className={styles.td}>{overAllTotal?.label}</td>
            <td className={styles.td}>{overAllTotal?.manpower_count}</td>
            <td className={styles.td}>{overAllTotal?.target}</td>
            <td className={styles.td}>{overAllTotal?.achieved}</td>
            <td className={styles.td}>{overAllTotal?.achievement_pct}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
